import { render, staticRenderFns } from "./PrivilegeHistory.vue?vue&type=template&id=248c99ec&scoped=true"
import script from "./PrivilegeHistory.vue?vue&type=script&lang=js"
export * from "./PrivilegeHistory.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeHistory.vue?vue&type=style&index=0&id=248c99ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c99ec",
  null
  
)

export default component.exports